function SearchMenu(el) {
    this.el = el;

    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsSearchMenuClose')) {
            e.preventDefault();
            this.hide();
        }
    });

    this.el.addEventListener('submit', e => {
        e.preventDefault();

        const inputValue = e.target.querySelector('input').value;
        const postType = e.target.querySelector('select').value;
        let urlSuffix = '/?s=' + inputValue;

        if (postType !== '-1') urlSuffix += '&pt=' + postType;

        window.location.replace(se_ajax.siteurl + urlSuffix);
    });
}

SearchMenu.prototype.show = function() {
    document.body.classList.add('no-overflow');
    this.el.classList.add('visible');

    const input = this.el.querySelector('input');
    input.focus();
};

SearchMenu.prototype.hide = function() {
    this.el.classList.remove('visible');
    document.body.classList.remove('no-overflow');
};

(function() {
    const searchMenuEl = document.querySelector('.jsSearchMenu');
    if (searchMenuEl) {
        const searchMenu = new SearchMenu(searchMenuEl);

        document.body.addEventListener('click', e => {
            if (e.target.classList.contains('jsTriggerSearchMenu')) {
                e.preventDefault();
                searchMenu.show();
            }
        });
    }
})();
